export default "__VITE_ASSET__BNTGSgZc__"